import { getConfig } from '@newfront-insurance/shared-public-config';

/** Where a chat sends turns, and which protocol it speaks. */
export type NovaChatBackend =
  /** Nova's durable v2 API: turns run as workflows a chat resumes by run id, stops explicitly and regenerates. */
  | { kind: 'nova-v2' }
  /** A plain AI SDK chat endpoint, such as Benji's: `api` takes turns and `${api}/:chatId/stream` resumes one. */
  | { kind: 'ai-sdk'; api: string };

export const NOVA_V2_CHAT_BACKEND: NovaChatBackend = { kind: 'nova-v2' };

const NOVA_V2_CHAT_COMPLETIONS_ENDPOINT = '/api/ai/nova/v2/chat/completions';

/** The URL a backend takes turns at. Its stream and stop URLs hang off it. */
export function chatBackendApi(backend: NovaChatBackend): string {
  if (backend.kind === 'ai-sdk') {
    return backend.api;
  }

  return `${getConfig().API.AI}${NOVA_V2_CHAT_COMPLETIONS_ENDPOINT}`;
}
